'use client';

import { useState, useRef, useEffect } from 'react';
import Image from 'next/image';

import { Analytics } from '@/components/(homepage)/analytics/analytics.component';

import { VimeoPlayer as Vimeo } from '@/elements/vimeo-player/vimeo-player.component';
import { ModalVideoWrapper as ModalVideo } from '@/elements/modal-video/modal-video.component';
import {
  Container,
  VideoWrap,
  VideoFilter,
  LogoContainer,
  MainContent,
  Content,
  Message,
  Title,
  Subtitle,
  Controls,
} from './hero.elements';

import izvrsnostLogoLight from '@/assets/svg/main-logo.svg';
import {
  IconVolume3,
  IconVolume,
  IconPlayerPauseFilled,
  IconPlayerPlayFilled,
  IconMaximize,
} from '@tabler/icons-react';

const Hero = ({
  data: {
    izvrsniTrailerId,
    lecturersCount,
    educationsCount,
    registrationsCount,
    averageEducationGrade,
  },
}) => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const [muted, setMuted] = useState(true);
  const [playing, setPlaying] = useState(false);
  const [clearScreen, setClearScreen] = useState(false);
  const timeoutRef = useRef(null);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleMaximize = () => {
    setShowFullScreen(true);
    setPlaying(false);
  };

  const handlePlayVideo = (value) => {
    setPlaying(value);

    // Clear any existing timeout
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(
      () => {
        setClearScreen(value);
      },
      value ? 3000 : 0
    );
  };

  return (
    <>
      <Container>
        <MainContent>
          <VideoWrap>
            <VideoFilter $playing={playing} $clearScreen={clearScreen} />
            {izvrsniTrailerId ? (
              <Vimeo
                video={izvrsniTrailerId}
                responsive
                autoplay
                muted
                volume={muted ? 0 : 1}
                background
                paused={!playing}
                controls={false}
                showTitle={false}
                keyboard={false}
                playsInline
                onPause={() => setClearScreen(false)}
                onPlay={() => handlePlayVideo(true)}
                onEnd={() => handlePlayVideo(false)}
              />
            ) : null}
            {izvrsniTrailerId ? (
              <Controls>
                <IconMaximize size={32} onClick={handleMaximize} />
                {muted ? (
                  <IconVolume3 size={34} onClick={() => setMuted(!muted)} />
                ) : (
                  <IconVolume size={34} onClick={() => setMuted(!muted)} />
                )}
                {playing ? (
                  <IconPlayerPauseFilled size={34} onClick={() => setPlaying(!playing)} />
                ) : (
                  <IconPlayerPlayFilled size={34} onClick={() => setPlaying(!playing)} />
                )}
              </Controls>
            ) : null}
          </VideoWrap>
          <Content $clearScreen={clearScreen}>
            <Message>
              <Title>
                Izvrsnost je u tebi,
                <br />
                izgradi je s nama
              </Title>
              <Subtitle>Najbolje edukacije za osobni razvoj - besplatno</Subtitle>
            </Message>
            <LogoContainer>
              <Image
                src={izvrsnostLogoLight}
                alt="Inkubator izvrsnosti logo"
                id="hero-logo"
                width={0}
                height={0}
                sizes="100vw"
                style={{
                  objectFit: 'cover',
                  maxWidth: '90%',
                  width: 'auto',
                  height: 'auto',
                }}
              />
            </LogoContainer>
          </Content>
        </MainContent>
        <Analytics
          data={{
            lecturersCount,
            educationsCount,
            registrationsCount,
            averageEducationGrade,
          }}
        />
      </Container>
      <ModalVideo
        channel="vimeo"
        autoplay
        isOpen={showFullScreen}
        videoId={izvrsniTrailerId}
        onClose={() => setShowFullScreen(false)}
      />
    </>
  );
};

export { Hero };
